import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["columns", "children", "hasBadgeOnFirstColumn", "hasBadgeOnLastColumn"];
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import { PPUIGrid } from '../grid/PPUIGrid';
import { useIsMobile } from '../hooks/useMedia';

/**
 * Builds the grid template areas for the shadow columns
 * @param columnCount - The number of columns in the grid
 * @returns The grid template areas, in this format:
 * "Title Title Title"
 * "Subheading Subheading Subheading"
 * "Pricing Pricing Pricing"
 * "Seats Seats Seats"
 * "Term Term Term"
 * "CTAs CTAs CTAs"
 * "Credits Credits Credits"
 * "Subtext Subtext Subtext"
 * "Features Features Features"
 * "Footer Footer Footer"
 */
import { jsx as _jsx } from "react/jsx-runtime";
const buildGridTemplateAreas = columnCount => {
  const sections = ['Badge', 'Title', 'Subheading', 'AbovePricing', 'Pricing', 'Seats', 'Term', 'CTAs', 'Credits', 'Subtext', 'Features', 'Footer'];
  return sections.map(section => `"${Array(columnCount).fill(section).join(' ')}"`).join('\n');
};
export const MerchCardColumns = _ref => {
  let {
      columns,
      children,
      hasBadgeOnFirstColumn = false,
      hasBadgeOnLastColumn = false
    } = _ref,
    gridProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const isMobile = useIsMobile();
  const getMaxInlineSize = () => {
    if (columns > 2) {
      return 'initial';
    }
    const baseWidth = isMobile ? 450 : 350;
    return `calc(${baseWidth}px * ${columns})`;
  };
  return /*#__PURE__*/_jsx(PPUIGrid, Object.assign({
    position: "relative",
    gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`,
    columnGap: "0",
    maxInlineSize: getMaxInlineSize(),
    inlineSize: "100%",
    marginInline: "auto",
    backgroundColor: "fill-surface-default",
    boxShadow: "100",
    blockSize: "100%",
    borderWidth: "100",
    borderStyle: "solid",
    borderColor: "border-core-subtle",
    borderStartStartRadius: isTrellis && hasBadgeOnFirstColumn ? '0' : '300',
    borderStartEndRadius: isTrellis && hasBadgeOnLastColumn ? '0' : '300',
    borderEndStartRadius: "300",
    borderEndEndRadius: "300",
    gridTemplateAreas: buildGridTemplateAreas(columns)
  }, gridProps, {
    children: children
  }));
};